import React, { Component } from "react";
import { BsyUtils } from "../../utils/Utils";
import BsySwitchBtn from "../BsySwitchBtn";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyCheckGroup from "../BsyCheckGroup";
import { createTooltip } from "../../utils/createTooltip";

export default class ManagerPane extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apps: [...props.apps],
      dept_range: [...props.dept_range],
      role_range: [...props.role_range],
      outsider_range: [...props.outsider_range],
      members: [...props.members],
      name: props.name,
      op: { ...props.op },
      owner: { ...props.owner },
      group_id: props.group_id,
    };
  }
  componentDidMount = () => {
    const { show, hide } = createTooltip();
    this.showTooltip = show;
    this.hideTooltip = hide;
  };

  componentWillUnmount() {
    this.hideTooltip();
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    this.setState({
      apps: [...nextProps.apps],
      dept_range: [...nextProps.dept_range],
      role_range: [...nextProps.role_range],
      outsider_range: [...nextProps.outsider_range],
      members: [...nextProps.members],
      name: nextProps.name,
      op: { ...nextProps.op },
      owner: { ...nextProps.owner },
      group_id: nextProps.group_id,
    });
  }

  addMembers = () => {
    const { members, group_id } = this.state;
    let member = members.map((dd, cc) => {
      return dd._id;
    });
    let that = this;
    const d = new window.FX.ConfirmDialog({
      title: React.language("member.select.list"),
      height: 586,
      width: 956,
      contentWidget: {
        rowSize: [450],
        colSize: [926],
        padding: 15,
        items: [
          [
            {
              widgetName: "memberSelect",
              type: "memberselectpane",

              editable: !0,
              hasDock: false,
              memberEnable: !0,
              departmentEnable: !1,
              outsiderMemberEnable: group_id === -1 ? !1 : !0,
              outsiderGroupEnable: !1,
              roleEnable: !1,
              dynamicEnable: !1,
              dynamicType: "set",
              value: member,
            },
          ],
        ],
      },
      onOk: function () {
        var dept = d.getWidgetByName("memberSelect");
        var d1 = dept.getAllJsonValue();
        if (!d1) {
          return;
        }
        const newMember = [...d1.users, ...d1.outsiderMember];
        React.axios("/corp/manage/group/update", {
          members: newMember,
          group_id: that.state.group_id,
          corpId: window.FX.STATIC.corpId,
        })
          .then((res) => {
            const members = newMember.map((item, index) => {
              //selectMap

              return {
                nickname: dept.selectMap[item].name,
                type: dept.selectMap[item].type,
                _id: item,
              };
            });
            // const newGroups = groups.map((item, index) => {
            //     if (item.group_id == node.group_id) {
            //         item.name = value;
            //     }
            //     return item;
            // })
            that.setState({
              groups: that.state.group_id,
              members: members,
            });
          })
          .catch((res) => {
            console.log(res);
          });

        // React.axios("/corp/outsider/member/transfer", {
        //     user_id: b,
        //     departmentId: d1.departs
        // }).then(res => {
        //     BsyUtils.showAjaxTip(res.data, () => {
        //         that.RefreshList();
        //     })

        // }).catch(res => {

        // })
        return !1;
      },
    });
    d.show();
  };

  addApps = () => {
    const { apps } = this.state;

    let that = this;

    new window.FX.ConfirmDialog({
      height: 565,
      width: 590,
      title: React.language("app.list"),
      contentWidget: {
        rowSize: [425],
        colSize: [570],
        padding: 16,
        items: [
          [
            {
              type: "appselectpane",
              widgetName: "sub_app",
              corpId: window.FX.STATIC.corpId,
              editable: !0,
              value: apps,
            },
          ],
        ],
      },
      onOk: function () {
        let i = this.getWidgetByName("sub_app");
        const app = i.getValue();
        let n = app.map((item, index) => {
          return item._id;
        });
        // console.log(app)
        React.axios("/corp/manage/group/update", {
          apps: n,
          group_id: that.state.group_id,
          corpId: window.FX.STATIC.corpId,
        })
          .then((res) => {
            that.setState({
              groups: that.state.group_id,
              apps: app,
            });
          })
          .catch((res) => {
            console.log(res);
          });
        return !1;
        // FX.Utils.forEach(i.getValue(), function(e, t) {
        //     n.push(t._id)
        // });
        // var a = this;
      },
    }).show();
  };

  addDepartments = () => {
    const { dept_range } = this.state;
    let member = dept_range.map((dd, cc) => {
      return dd._id;
    });
    let that = this;
    const d = new window.FX.ConfirmDialog({
      title: React.language("member.select.list"),
      height: 586,
      width: 956,
      contentWidget: {
        rowSize: [450],
        colSize: [926],
        padding: 15,
        items: [
          [
            {
              widgetName: "memberSelect",
              type: "memberselectpane",

              editable: !0,
              memberEnable: !1,
              departmentEnable: !0,
              outsiderMemberEnable: !1,
              outsiderGroupEnable: !1,
              roleEnable: !1,
              dynamicEnable: !1,
              hasDock: false,
              dynamicType: "set",
              jsonValue: {
                departs: member,
                users: [],
              },
            },
          ],
        ],
      },
      onOk: function () {
        var dept = d.getWidgetByName("memberSelect");
        var d1 = dept.getAllJsonValue();
        if (!d1) {
          return;
        }

        React.axios("/corp/manage/group/update", {
          dept_range: d1.departs,
          group_id: that.state.group_id,
          corpId: window.FX.STATIC.corpId,
        })
          .then((res) => {
            const members = d1.departs.map((item, index) => {
              //selectMap

              return {
                name: dept.selectMap[item].name,
                _id: item,
              };
            });
            // const newGroups = groups.map((item, index) => {
            //     if (item.group_id == node.group_id) {
            //         item.name = value;
            //     }
            //     return item;
            // })
            that.setState({
              groups: that.state.group_id,
              dept_range: members,
            });
          })
          .catch((res) => {
            console.log(res);
          });

        return !1;
      },
    });
    d.show();
  };

  addRole = () => {
    const { role_range } = this.state;
    let member = role_range.map((dd, cc) => {
      return dd._id;
    });
    let that = this;
    const d = new window.FX.ConfirmDialog({
      title: React.language("member.select.list"),
      height: 586,
      width: 956,
      contentWidget: {
        rowSize: [450],
        colSize: [926],
        padding: 15,
        items: [
          [
            {
              widgetName: "memberSelect",
              type: "memberselectpane",

              editable: !0,
              memberEnable: !1,
              departmentEnable: !1,
              outsiderMemberEnable: !1,
              outsiderGroupEnable: !1,
              roleEnable: !0,
              roleChildEnable: !1,
              dynamicEnable: !1,
              dynamicType: "set",
              hasDock: false,
              value: member,
            },
          ],
        ],
      },
      onOk: function () {
        var dept = d.getWidgetByName("memberSelect");
        var d1 = dept.getAllJsonValue();
        if (!d1) {
          return;
        }

        React.axios("/corp/manage/group/update", {
          role_range: d1.roles,
          group_id: that.state.group_id,
          corpId: window.FX.STATIC.corpId,
        })
          .then((res) => {
            const members = d1.roles.map((item, index) => {
              //selectMap

              return {
                id: dept.selectMap[item].role_id,
                type: dept.selectMap[item].type,
                mode: dept.selectMap[item].mode,
                name: dept.selectMap[item].name,
                _id: item,
              };
            });
            // const newGroups = groups.map((item, index) => {
            //     if (item.group_id == node.group_id) {
            //         item.name = value;
            //     }
            //     return item;
            // })
            that.setState({
              groups: that.state.group_id,
              role_range: members,
            });
          })
          .catch((res) => {
            console.log(res);
          });

        return !1;
      },
    });
    d.show();
  };

  addOutsider = () => {
    const { outsider_range } = this.state;
    let member = outsider_range.map((dd, cc) => {
      return dd._id;
    });
    let that = this;
    const d = new window.FX.ConfirmDialog({
      title: React.language("member.select.list"),
      height: 586,
      width: 956,
      contentWidget: {
        rowSize: [450],
        colSize: [926],
        padding: 15,
        items: [
          [
            {
              widgetName: "memberSelect",
              type: "memberselectpane",

              editable: !0,
              memberEnable: !1,
              departmentEnable: !1,
              outsiderMemberEnable: !1,
              outsiderGroupEnable: !0,
              roleEnable: !1,
              dynamicEnable: !1,
              dynamicType: "set",
              hasDock: false,
              jsonValue: {
                outsiderGroup: member,
                users: [],
              },
            },
          ],
        ],
      },
      onOk: function () {
        var dept = d.getWidgetByName("memberSelect");
        var d1 = dept.getAllJsonValue();
        if (!d1) {
          return;
        }

        React.axios("/corp/manage/group/update", {
          outsider_range: d1.outsiderGroup,
          group_id: that.state.group_id,
          corpId: window.FX.STATIC.corpId,
        })
          .then((res) => {
            const members = d1.outsiderGroup.map((item, index) => {
              //selectMap

              return {
                name: dept.selectMap[item].name,
                type: "outsiderGroup",
                _id: item,
              };
            });
            that.setState({
              groups: that.state.group_id,
              outsider_range: members,
            });
          })
          .catch((res) => {
            console.log(res);
          });

        return !1;
      },
    });
    d.show();
  };

  switchChange = (e) => {
    const newOp = {
      ...this.state.op,
      ...e,
    };
    React.axios("/corp/manage/group/update", {
      op: newOp,
      group_id: this.state.group_id,
      corpId: window.FX.STATIC.corpId,
    })
      .then((res) => {
        this.setState(
          {
            op: newOp,
          },
          () => {
            tipAlert({
              type: "success",
              msg: React.language("saveInfo.update.save"),
            });
          }
        );
      })
      .catch((res) => {
        console.log(res);
      });
  };

  _addavatar = (d) => {
    if (d.avatarurl) {
      return <img className="user-center" alt="" src={d.avatarurl}></img>;
    } else {
      if (d.nickname) {
        var bg = d.nickname
          ? BsyUtils.formatUserThumb(d.nickname.toString())
          : "";
        return (
          <>
            <span className={"table-user-portrait-name color-" + bg.color}>
              <span style={{ float: "unset" }}>{bg.name[0]}</span>
            </span>
          </>
        );
      }
    }
    return "";
  };

  render() {
    let that = this;
    const {
      group_id,
      owner,
      members,
      apps,
      op,
      dept_range,
      outsider_range,
      role_range,
    } = this.state;
    const { is_tmp_owner } = this.props;
    let userInviteVal = [];
    let userRemoveVal = [];
    let organizationRemoveVal = [];
    let userInviteItems = [];
    let userRemoveItems = [];
    let organizationRemoveItems = [];
    if (BsyUtils.isTripartite()) {
      if (op.outsiderMemberInvite) {
        userInviteVal.push(1);
      }

      if (op.outsiderMemberRemove) {
        userRemoveVal.push(1);
      }

      if (op.outsiderRemove) {
        organizationRemoveVal.push(1);
      }

      userInviteItems = [
        { value: 1, text: React.language("external.contact.invitation") },
      ];

      userRemoveItems = [
        { value: 1, text: React.language("external.contact.deletion") },
      ];

      organizationRemoveItems = [
        { value: 1, text: React.language("group.deletion") },
      ];
    } else {
      if (op.memberInvite) {
        userInviteVal.push(0);
      }
      if (op.outsiderMemberInvite) {
        userInviteVal.push(1);
      }

      if (op.memberRemove) {
        userRemoveVal.push(0);
      }
      if (op.outsiderMemberRemove) {
        userRemoveVal.push(1);
      }

      if (op.deptRemove) {
        organizationRemoveVal.push(0);
      }
      if (op.outsiderRemove) {
        organizationRemoveVal.push(1);
      }

      userInviteItems = [
        { value: 0, text: React.language("member.invitation") },
        { value: 1, text: React.language("external.contact.invitation") },
      ];

      userRemoveItems = [
        { value: 0, text: React.language("member.deletion") },
        { value: 1, text: React.language("external.contact.deletion") },
      ];

      organizationRemoveItems = [
        { value: 0, text: React.language("department.deletion") },
        { value: 1, text: React.language("group.deletion") },
      ];
    }

    return (
      <div className={"sysManagerConfig"}>
        {group_id === -1 ? (
          <div className="config-line">
            <div className="line-item left align-middle">
              {React.language("manager.creator")}
            </div>
            <div className="line-item right align-middle">
              {owner.nickname + (owner.phone ? "(" + owner.phone + ")" : "")}
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="config-line">
          {
            //管理员
          }
          <div className="line-item left align-middle">
            {group_id === -1
              ? React.language("manager.system")
              : React.language("manager")}
          </div>
          <div
            className={
              "line-item right align-middle " +
              (members.length > 0 ? "padding-small" : "")
            }
          >
            {
              //.padding-small
              members.length == 0 ? (
                <div
                  className="item-btn"
                  onClick={(e) => {
                    that.addMembers(members);
                  }}
                >
                  <i className="icon-add"></i>
                  <span>{React.language("manager.create.tip")}</span>
                </div>
              ) : (
                <>
                  {members.map((item, index) => {
                    return (
                      <div className="item-content member">
                        {this._addavatar(item)}
                        <span>{BsyUtils._toDeptUser(item)}</span>
                      </div>
                    );
                  })}
                  <div
                    className="item-btn-edit"
                    onClick={(e) => {
                      that.addMembers(members);
                    }}
                  >
                    {React.language("modify")}
                  </div>
                </>
              )
            }
          </div>
        </div>
        <div className="config-line">
          {
            //应用权限
          }
          <div className="line-item left align-middle">
            {React.language("manager.appAuth")}
          </div>
          <div
            className={
              "line-item right align-middle " +
              (members.length > 0 ? "padding-small" : "")
            }
          >
            {group_id == -1 ? (
              React.language("manager.appAuth.tip")
            ) : (
              <>
                {
                  //.padding-small
                  apps.length == 0 ? (
                    <div
                      className="item-btn"
                      onClick={(e) => {
                        that.addApps();
                      }}
                    >
                      <i className="icon-add"></i>
                      <span>{React.language("manager.appAuth.edit.tip")}</span>
                    </div>
                  ) : (
                    <>
                      {apps.map((item, index) => {
                        return (
                          <div className={"item-content"}>
                            <div
                              className={
                                " app-icon color-cover-" + item.style.color
                              }
                            >
                              {" "}
                              <div
                                className={
                                  "imgbg-bsy-app imgbg-bsy-app-" +
                                  item.style.icon
                                }
                              ></div>
                            </div>

                            <span>{item.name}</span>
                          </div>
                        );
                      })}
                      <div
                        className="item-btn-edit"
                        onClick={(e) => {
                          that.addApps();
                        }}
                      >
                        {React.language("modify")}
                      </div>
                    </>
                  )
                }
              </>
            )}
          </div>
        </div>
        {!is_tmp_owner && (
          <div className="config-line">
            {
              //功能权限
            }
            <div className="line-item left align-middle">
              {React.language("manager.funcAuth")}{" "}
            </div>
            <div className="line-item right align-middle">
              {group_id == -1 ? (
                React.language("manager.funcAuth.tip")
              ) : (
                <>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div className="inline-left">
                      {React.language("manager.funcAuth.contacts")}
                    </div>
                    {
                      <BsySwitchBtn
                        switchChange={(e) => {
                          this.switchChange({ memberManage: e });
                        }}
                        power={op.memberManage}
                      />
                    }
                  </div>
                  {BsyUtils.isCommon() ? (
                    ""
                  ) : op.memberManage ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div className="inline-left">
                        {React.language("manager.sync")}
                      </div>
                      {
                        <BsySwitchBtn
                          switchChange={(e) => {
                            this.switchChange({ syncUser: e });
                          }}
                          power={op.syncUser}
                        />
                      }
                    </div>
                  ) : (
                    ""
                  )}
                </>
              )}
            </div>
          </div>
        )}
        {!is_tmp_owner && op.memberManage && group_id != -1 && (
          <>
            <div className="config-line">
              {
                //人员邀请
              }
              <div className="line-item left align-middle">
                {React.language("personnel.invitation")}
              </div>
              <div className="line-item right align-middle">
                <div className="time-cont">
                  <BsySwitchBtn
                    switchChange={(e) => {
                      this.switchChange({ userInvite: e });
                    }}
                    power={op.userInvite}
                  />
                  {op.userInvite && (
                    <BsyCheckGroup
                      layout={"horizontal"}
                      value={userInviteVal}
                      items={userInviteItems}
                      onStopEdit={(e) => {
                        let memberInvite = false;
                        let outsiderMemberInvite = false;
                        if (e.indexOf(0) > -1) memberInvite = true;

                        if (e.indexOf(1) > -1) outsiderMemberInvite = true;
                        this.switchChange({
                          memberInvite,
                          outsiderMemberInvite,
                        });
                      }}
                    ></BsyCheckGroup>
                  )}
                </div>
              </div>
            </div>
            <div className="config-line">
              {
                //人员删除
              }
              <div className="line-item left align-middle">
                {React.language("personnel.deletion")}
              </div>
              <div className="line-item right align-middle">
                <div className="time-cont">
                  <BsySwitchBtn
                    switchChange={(e) => {
                      this.switchChange({ userRemove: e });
                    }}
                    power={op.userRemove}
                  />
                  {op.userRemove && (
                    <BsyCheckGroup
                      layout={"horizontal"}
                      value={userRemoveVal}
                      items={userRemoveItems}
                      onStopEdit={(e) => {
                        let memberRemove = false;
                        let outsiderMemberRemove = false;
                        if (e.indexOf(0) > -1) memberRemove = true;

                        if (e.indexOf(1) > -1) outsiderMemberRemove = true;
                        this.switchChange({
                          memberRemove,
                          outsiderMemberRemove,
                        });
                      }}
                    ></BsyCheckGroup>
                  )}
                </div>
              </div>
            </div>
            <div className="config-line">
              {
                //部门/外部联系人分组删除
              }
              <div className="line-item left align-middle">
                {React.language("department.external.group.deletion")}
              </div>
              <div className="line-item right align-middle">
                <div className="time-cont">
                  <BsySwitchBtn
                    switchChange={(e) => {
                      this.switchChange({ organizationRemove: e });
                    }}
                    power={op.organizationRemove}
                  />
                  {op.organizationRemove && (
                    <BsyCheckGroup
                      layout={"horizontal"}
                      value={organizationRemoveVal}
                      items={organizationRemoveItems}
                      onStopEdit={(e) => {
                        let deptRemove = false;
                        let outsiderRemove = false;
                        if (e.indexOf(0) > -1) deptRemove = true;

                        if (e.indexOf(1) > -1) outsiderRemove = true;
                        this.switchChange({ deptRemove, outsiderRemove });
                      }}
                    ></BsyCheckGroup>
                  )}
                </div>
              </div>
            </div>
          </>
        )}

        <div className="config-line">
          {
            //安全策略
          }
          <div className="line-item left align-middle">
            {React.language("security.strategy")}
          </div>
          <div className="line-item right align-middle">
            {group_id == -1 ? (
              React.language("security.policy")
            ) : (
              <div style={{ display: "flex", alignItems: "center" }}>
                <div className="inline-left">
                  {React.language("security.policy1")}
                </div>
                {
                  <BsySwitchBtn
                    switchChange={(e) => {
                      this.switchChange({ is_sec_pol: e });
                    }}
                    power={op.is_sec_pol}
                  />
                }
              </div>
            )}
          </div>
        </div>
        {!is_tmp_owner && (
          <div className="config-line">
            {
              //通讯录管理范围
            }
            <div className="line-item left align-middle">
              {React.language("manager.contacts.range")}
              {group_id === -1 ? (
                ""
              ) : (
                <span className="tip">
                  <i
                    data-tip={React.language("outdiser.subadmin.tip1")}
                    className="icon-shixinhelp"
                    data-place={"top"}
                    data-type={window.mode}
                    data-html={true}
                    data-class="mytip"
                    onMouseEnter={(e) => {
                      this.showTooltip(
                        e.currentTarget,
                        React.language("outdiser.subadmin.tip1"),
                        "bottom",
                        10
                      );
                    }}
                    onMouseLeave={() => {
                      this.hideTooltip();
                    }}
                  ></i>
                </span>
              )}
            </div>
            <div className="line-item right align-middle">
              {group_id === -1 ? (
                React.language("manager.contacts.range.tip")
              ) : (
                <>
                  {
                    //.padding-small
                    dept_range.length == 0 ? (
                      <>
                        <div
                          className="item-btn"
                          onClick={(e) => {
                            that.addDepartments();
                          }}
                        >
                          <i className="icon-add"></i>
                          <span>
                            {React.language("manager.contacts.range.edit.tip")}
                          </span>
                        </div>
                        <div className="sub-info">
                          {React.language("manager.contacts.range.empty.tip")}
                        </div>
                      </>
                    ) : (
                      <>
                        {dept_range.map((item, index) => {
                          return (
                            <div className={"item-content department"}>
                              <i
                                style={{
                                  color: "#0265ff",
                                }}
                                className="icon-department"
                              />

                              <span>{item.name}</span>
                            </div>
                          );
                        })}
                        <div
                          className="item-btn-edit"
                          onClick={(e) => {
                            that.addDepartments();
                          }}
                        >
                          {React.language("modify")}
                        </div>
                      </>
                    )
                  }
                </>
              )}
            </div>
          </div>
        )}
        {!is_tmp_owner && (
          <div className="config-line">
            {
              //角色组管理范围
            }
            <div className="line-item left align-middle">
              {React.language("role.contacts.range")}
              {group_id === -1 ? (
                ""
              ) : (
                <span className="tip">
                  <i
                    data-tip={React.language("outdiser.subadmin.tip1")}
                    className="icon-shixinhelp"
                    data-place={"top"}
                    data-type={window.mode}
                    data-html={true}
                    data-class="mytip"
                    onMouseEnter={(e) => {
                      this.showTooltip(
                        e.currentTarget,
                        React.language("outdiser.subadmin.tip1"),
                        "bottom",
                        10
                      );
                    }}
                    onMouseLeave={() => {
                      this.hideTooltip();
                    }}
                  ></i>
                </span>
              )}
            </div>
            <div className="line-item right align-middle">
              {group_id === -1 ? (
                React.language("role.contacts.range.tip")
              ) : (
                <>
                  {
                    //.padding-small
                    role_range.length === 0 ? (
                      <>
                        <div
                          className="item-btn"
                          onClick={(e) => {
                            that.addRole();
                          }}
                        >
                          <i className="icon-add"></i>
                          <span>
                            {React.language("role.contacts.range.edit.tip")}
                          </span>
                        </div>
                        <div className="sub-info">
                          {React.language("role.contacts.range.empty.tip")}
                        </div>
                      </>
                    ) : (
                      <>
                        {role_range.map((item, index) => {
                          return (
                            <div
                              className={`item-content ${
                                item.mode || item.type
                              }`}
                            >
                              <i
                                className={
                                  item.mode === "role" || item.type === "role"
                                    ? "icon-role"
                                    : "icon-role-group"
                                }
                              />

                              <span>
                                {item.name +
                                  (item.mode === "roleGroupSub" ||
                                  item.type === "roleGroupSub"
                                    ? React.language("and.sub.group")
                                    : "")}
                              </span>
                            </div>
                          );
                        })}
                        <div
                          className="item-btn-edit"
                          onClick={(e) => {
                            that.addRole();
                          }}
                        >
                          {React.language("modify")}
                        </div>
                      </>
                    )
                  }
                </>
              )}
            </div>
          </div>
        )}

        {!is_tmp_owner && (
          <div className="config-line">
            {
              //外部管理人
            }
            <div className="line-item left align-middle">
              {React.language("outsider.contacts.range")}
            </div>
            <div className="line-item right align-middle">
              {group_id == -1 ? (
                React.language("outsider.contacts.range.tip")
              ) : (
                <>
                  {
                    //.padding-small
                    outsider_range.length == 0 ? (
                      <>
                        <div
                          className="item-btn"
                          onClick={(e) => {
                            that.addOutsider();
                          }}
                        >
                          <i className="icon-add"></i>
                          <span>
                            {React.language("outsider.contacts.range.edit.tip")}
                          </span>
                        </div>
                        <div className="sub-info">
                          {React.language("outsider.contacts.range.empty.tip")}
                        </div>
                      </>
                    ) : (
                      <>
                        {outsider_range.map((item, index) => {
                          return (
                            <div className={"item-content outsiderGroup"}>
                              <i
                                style={{
                                  color: "#4acc8c",
                                }}
                                className="icon-outsider-group"
                              />

                              <span>{item.name}</span>
                            </div>
                          );
                        })}
                        <div
                          className="item-btn-edit"
                          onClick={(e) => {
                            that.addOutsider();
                          }}
                        >
                          {React.language("modify")}
                        </div>
                      </>
                    )
                  }
                </>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}
